import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import ImageRule1 from "@/assets/custom-digital-human-rule/image_rule_1.webp";
import ImageRule2 from "@/assets/custom-digital-human-rule/image_rule_1@2x.webp";
import ImageRule3 from "@/assets/custom-digital-human-rule/image_rule_1@3x.webp";

export const ImageRule1Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[ImageRule3]}
      {...props}
    />
  );
};

ImageRule1Image.displayName = 'ImageRule1Image';
